import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface ICellRendererParamsForCapRoleListGridAction extends ICellRendererParams {
    viewDetails: (params: ICellRendererParamsForCapRoleListGridAction) => void;
}

@Component({
    selector: 'cap-rule-list-grid-action-cell',
    template:
        `
        <button class="ace-btn btn-primary has-icon grid-action-button" (click)="onViewDetailsClicked()">
            <i class="fa fa-pencil"></i>
        </button>
        `,
    standalone: false
})
export class CapRuleListGridActionCellRendererComponent implements ICellRendererAngularComp {
    capRuleModel: Core.CapRuleModel;

    private _params: ICellRendererParamsForCapRoleListGridAction;

    agInit(params: ICellRendererParamsForCapRoleListGridAction): void {
        this._params = params;
        this.capRuleModel = params.data as Core.CapRuleModel;
        if (!this.capRuleModel) {
            return;
        }
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onViewDetailsClicked(): void {
        this._params.viewDetails(this._params);
    }
}
